export const enum CommonAggregationType {
  COUNT_ALL = 'COUNT_ALL',
  COUNT_EMPTY = 'COUNT_EMPTY',
  COUNT_NOT_EMPTY = 'COUNT_NOT_EMPTY',
  COUNT_UNIQUE_VALUES = 'COUNT_UNIQUE_VALUES',
  COUNT_VALUES = 'COUNT_VALUES',
  PERCENT_EMPTY = 'PERCENT_EMPTY',
  PERCENT_NOT_EMPTY = 'PERCENT_NOT_EMPTY'
}

export const enum NumericAggregationType {
  AVERAGE = 'AVERAGE',
  COUNT_ALL = 'COUNT_ALL',
  COUNT_EMPTY = 'COUNT_EMPTY',
  COUNT_NOT_EMPTY = 'COUNT_NOT_EMPTY',
  COUNT_UNIQUE_VALUES = 'COUNT_UNIQUE_VALUES',
  COUNT_VALUES = 'COUNT_VALUES',
  MAX = 'MAX',
  MEDIAN = 'MEDIAN',
  MIN = 'MIN',
  PERCENT_EMPTY = 'PERCENT_EMPTY',
  PERCENT_NOT_EMPTY = 'PERCENT_NOT_EMPTY',
  RANGE = 'RANGE',
  SUM = 'SUM'
}

export const enum DateAggregationType {
  AVERAGE = 'AVERAGE',
  COUNT_ALL = 'COUNT_ALL',
  COUNT_EMPTY = 'COUNT_EMPTY',
  COUNT_NOT_EMPTY = 'COUNT_NOT_EMPTY',
  COUNT_UNIQUE_VALUES = 'COUNT_UNIQUE_VALUES',
  COUNT_VALUES = 'COUNT_VALUES',
  PERCENT_EMPTY = 'PERCENT_EMPTY',
  PERCENT_NOT_EMPTY = 'PERCENT_NOT_EMPTY',
  DATE_RANGE = 'DATE_RANGE',
  EARLIEST_DATE = 'EARLIEST_DATE',
  LATEST_DATE = 'LATEST_DATE'
}
